function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import classNames from 'classnames';
import NoContextMenu from '../no-context-menu/no-context-menu.js';
import './table.scss';

class Table extends Component {
  render() {
    var {
      className,
      children,
      gridTemplateColumns,
      headers,
      rows,
      rowClickGroups,
      compactTableSettings = {},
      useCompactTable = false
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(`myTable ${className}`, {
        compactTable: useCompactTable
      })
    }, !useCompactTable && /*#__PURE__*/React.createElement("div", {
      className: "headerRow tableRow",
      style: {
        gridTemplateColumns
      }
    }, headers.map((header, i) => {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('headerCell tableCell', {
          emptyCell: !header
        }),
        key: i
      }, header);
    }), !!rowClickGroups?.length && /*#__PURE__*/React.createElement("div", {
      className: "headerCell tableCell"
    })), /*#__PURE__*/React.createElement("div", {
      className: "tableRowsContainer"
    }, rows.map((row, i) => /*#__PURE__*/React.createElement(TableRow, {
      gridTemplateColumns: gridTemplateColumns,
      key: i,
      row: row,
      rowNumber: i,
      rowClickGroups: rowClickGroups,
      compactTableSettings: compactTableSettings,
      useCompactTable: useCompactTable
    }))), children);
  }

}

class TableRow extends Component {
  state = {
    compactOpen: false
  };

  handleCompactArrowClick() {
    var {
      compactOpen
    } = this.state;
    this.setState({
      compactOpen: !compactOpen
    });
  }

  render() {
    var {
      gridTemplateColumns,
      row,
      rowNumber,
      rowClickGroups,
      compactTableSettings = {},
      useCompactTable = false
    } = this.props;
    var {
      compactOpen
    } = this.state;
    var compactHeaders = {};
    var includeClickAction = !!rowClickGroups?.length;
    var newRow = includeClickAction ? row.slice(0, row.length - 1) : row;
    newRow = newRow.map((cell, i) => {
      if (typeof cell !== 'object') {
        cell = {
          value: cell
        };
      } else {
        cell = { ...cell
        };
      }

      if (cell.format === 'money') {
        var displayValue = null;

        if (cell.value == 0) {
          // eslint-disable-line eqeqeq
          displayValue = ' -   ';
        } else if (cell.value < 0) {
          displayValue = `(${Math.abs(cell.value).toFixed(2)})`;
        } else {
          displayValue = cell.value.toFixed(2);
        }

        cell.value = /*#__PURE__*/React.createElement(React.Fragment, null, "$", /*#__PURE__*/React.createElement("span", {
          className: classNames({
            positiveNumber: cell.value >= 0
          }),
          style: {
            float: 'right',
            whiteSpace: 'pre'
          }
        }, displayValue));
      } else {
        cell.value = cell.value.toString();
      }

      cell.style = cell.style || {};

      if (useCompactTable) {
        for (var [key, index] of Object.entries(compactTableSettings)) {
          if (i === index) {
            compactHeaders[key] = cell;
          }
        }
      }

      return cell;
    });
    var height = null;

    if (useCompactTable) {
      height = 50;

      if (compactOpen) {
        height += row.length * 21;
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(`tableRow ${rowNumber % 2 ? 'oddRow' : 'evenRow'}`, {
        compactRow: useCompactTable
      }),
      style: {
        gridTemplateColumns,
        height
      }
    }, useCompactTable && /*#__PURE__*/React.createElement("div", {
      className: "compactHeadersContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "compactHeader"
    }, compactHeaders.header?.value), /*#__PURE__*/React.createElement("div", {
      className: "compactSubHeader"
    }, compactHeaders.subHeader?.value), /*#__PURE__*/React.createElement("div", {
      className: "compactRightHeader"
    }, compactHeaders.rightHeader?.value), /*#__PURE__*/React.createElement("div", {
      className: "compactRightSubHeader"
    }, compactHeaders.rightSubHeader?.value), /*#__PURE__*/React.createElement("div", {
      className: "compactDropArrow",
      onClick: () => this.handleCompactArrowClick()
    }, compactOpen ? '^' : '>')), newRow.map((cell, j) => /*#__PURE__*/React.createElement("div", _extends({
      className: classNames('tableCell', cell.className, cell.format, cell.compactPosition, {
        emptyCell: !cell.value
      }),
      style: cell.style,
      key: j
    }, cell.events || {}), cell.value)), includeClickAction && /*#__PURE__*/React.createElement(NoContextMenu, {
      actionType: "click",
      alwaysCentered: true,
      groups: rowClickGroups,
      object: row[row.length - 1]
    }, /*#__PURE__*/React.createElement("div", {
      className: "tableCell clickActionCell"
    }, "\u2022\u2022\u2022")));
  }

}

export default Table;